import * as THREE from 'three';
import { state } from './state';
import { renderer, key, ambient, fill, rim } from './scene';

// Tanner Helland blackbody approximation -> linear-ish RGB (0..1)
function kelvinToRGB(k: number): { r: number; g: number; b: number } {
  const t = k / 100;
  let r: number, g: number, b: number;
  if (t <= 66) {
    r = 255;
    g = 99.4708025861 * Math.log(t) - 161.1195681661;
  } else {
    r = 329.698727446 * Math.pow(t - 60, -0.1332047592);
    g = 288.1221695283 * Math.pow(t - 60, -0.0755148492);
  }
  if (t >= 66) b = 255;
  else if (t <= 19) b = 0;
  else b = 138.5177312231 * Math.log(t - 10) - 305.0447927307;
  const cl = (v: number) => Math.max(0, Math.min(255, v)) / 255;
  return { r: cl(r), g: cl(g), b: cl(b) };
}

export function applyCalibration(): void {
  const rgb = kelvinToRGB(state.tempK);
  const gm = state.tint / 50; // + magenta, - green
  const col = new THREE.Color(
    Math.min(1, rgb.r * (1 + 0.1 * gm)),
    Math.min(1, rgb.g * (1 - 0.1 * gm)),
    Math.min(1, rgb.b * (1 + 0.1 * gm)),
  );
  key.color.copy(col);
  ambient.color.copy(col);
  fill.color.copy(col);
  rim.color.copy(col);
  renderer.toneMappingExposure = state.exposure;
}

export function syncCalibUI(): void {
  (document.getElementById('tempSlider') as HTMLInputElement).value = String(state.tempK);
  document.getElementById('tempVal')!.textContent = String(state.tempK);
  (document.getElementById('tintSlider') as HTMLInputElement).value = String(state.tint);
  document.getElementById('tintVal')!.textContent = String(state.tint);
  (document.getElementById('expSlider') as HTMLInputElement).value = String(state.exposure);
  document.getElementById('expVal')!.textContent = Number(state.exposure).toFixed(2);
}

export function setPresetCustom(): void {
  (document.getElementById('presetSel') as HTMLSelectElement).value = 'custom';
}
